import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import MediaItemStatsTable from '../../components/MediaItemStatsTable';
import { useMediaItemStats } from '../../hooks/stats';

const MediaItemStatsPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const { courseId, subjectId, mediaId } = useParams();

  const { loading, error, mediaStats, onFetchStats, onFilterStats, onGetXlsxData } = useMediaItemStats({
    courseId,
    subjectId,
    mediaId,
  });

  const onClickStudent = useCallback(
    (student) => {
      history.push(`/${courseId}/students/${student._id}/media-stats/${mediaId}?from=/${courseId}/media-stats/${subjectId}/${mediaId}`);
    },
    [history, courseId, mediaId, subjectId]
  );

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/media-stats`);
  }, [history, courseId]);

  return (
    <Box>
      <BackButton onGoBack={onGoBack} title={mediaStats?.media?.name} subtitle={intl.formatMessage({ id: 'quickLink.mediaStats' })} />
      <MediaItemStatsTable
        loading={loading}
        error={error}
        mediaStats={mediaStats}
        onFetchStats={onFetchStats}
        onFilterStats={onFilterStats}
        onClickStudent={onClickStudent}
        onGetXlsxData={onGetXlsxData}
      />
    </Box>
  );
};
export default MediaItemStatsPage;
